<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormMateriales" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <CList @FiltrarC="Recuperar" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
                        <template slot="header">
                            <th :class="StyleTh+' text-center'">#</th>
                            <th :class="StyleTh">Nombre</th>
                            <th :class="StyleTh">Categoría</th>
                            <th :class="StyleTh">Stock</th>
                            <th :class="StyleTh">Elegir</th>
                        </template>

                        <template slot="body">
                            <tr v-for="(lista,index) in Materiales" :key="index">
                                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                                <td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                                <td><p :class="StyleTd">{{ lista.Stock }}</p></td>
                                <td><p :class="StyleTd">{{ lista.producto_categoria.Nombre }}</p></td>
                                <td>
                                    <button @click="SeleccionMaterial(lista)" type="button" class="btn btn-link text-primary px-3 mb-0 mr-1"><i class="fas fa-check-circle text-primary"></i> Agregar</button>
                                    <input @change="AgregarQuitarCheck(lista)" type="checkbox" v-model="lista.Check">
                                </td>
                            </tr>
                        </template>
                    </CList>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
export default {
    name:'SeleccionMateriales',
    props:['poBtnSave','pObjSolicitudSalida'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
            Emit: this.poBtnSave.EmitSeccion,
            ConfigList:{
                Title:'Materiales',
                BtnNewShow:false,
                ShowTitleFirst: false,
                ShowLoader: false,
                ShowFooter:false
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                IdProductoCategoria:""
            },
            segurity: {},
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjSolicitudSalida:{},
            Materiales:[],
            MaterialesCheck:[]
        }
    },
    methods: {
        Recuperar(){
            this.ConfigList.ShowLoader=true;
            this.$http.get('materiales',
            {
                params:{
                    Nombre: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdProductoCategoria:this.Filtro.IdProductoCategoria,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                res.data.data.data.forEach((element)=>{
                    element.Check=false;
                })
                if (this.ObjSolicitudSalida.Materiales.length>0) {
                    res.data.data.data.forEach((element)=>{
                        let index=this.ObjSolicitudSalida.Materiales.findIndex((element2)=>element2.IdMaterial==element.IdMaterial);
                        // console.log(index);
                        if (index!=-1) {
                            element.Check=true;
                            this.MaterialesCheck.push(element);
                        }
                    });
                }
                if (this.MaterialesCheck.length>0) {
                    this.MaterialesCheck.forEach((element)=>{
                        let index=res.data.data.data.findIndex((element2)=>element2.IdMaterial==element.IdMaterial);
                        if (index!=-1) {
                            res.data.data.data[index].Check=true;
                        }
                    })
                }
                this.Materiales=res.data.data.data;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
                this.ConfigLoad.ShowLoader = false;
            });
        },
        // Limpiar(){
        //     this.MaterialesCheck=[];
        // },
        SeleccionMaterial(item){
            this.bus.$emit('AgregarMaterialModal',item)
        },
        AgregarQuitarCheck(item){
            if (item.Check) {
                this.MaterialesCheck.push(item);
            }
            else{
                let index=this.MaterialesCheck.findIndex((element)=>item.IdMaterial==element.IdMaterial);
                this.MaterialesCheck.splice(index,1);
            }
        },
        SeleccionMateriales(){
            this.Materiales.forEach((item)=>{
                if (item.Check) {
                    let index=this.ObjSolicitudSalida.Materiales.findIndex((element)=>element.IdMaterial==item.IdMaterial);
                    if (index==-1) {
                        this.bus.$emit('AgregarMaterialModal',item);
                    }
                }
            });
            this.bus.$emit('CloseModal_'+this.Emit);
        },

    },
    created() {
        this.ObjSolicitudSalida=this.pObjSolicitudSalida;
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>{
                this.SeleccionMateriales();
            });
            // this.Limpiar();
            // this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
            this.Recuperar();
        });
    },
}
</script>

<style>

</style>